import useUser from '@api/auth/useUser';
import { UserRole } from '@enums/UserRole';

type Action = 'read' | 'write';

const PermissionMap = new Map<string, Action[]>([
  [UserRole.READER, ['read']],
  [UserRole.EDITOR, ['read', 'write']],
]);

export const useHasPermission = (action: Action | undefined = 'write') =>
  useUser().roles.some(role => PermissionMap.get(role)?.includes(action) ?? false);

export type { Action };
